import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const QuoteFeature = ({ blok }) => {
  const backgroundImage = blok.background_image?.filename
    ? `url(${blok.background_image.filename})`
    : "none";

  return (
    <section
      {...storyblokEditable(blok)}
      className="flex justify-center items-center text-center text-white bg-cover bg-center"
      style={{
        backgroundImage,
        backgroundColor: backgroundImage === "none" ? "#0a1a3f" : "transparent",
        paddingTop: "calc(6rem + 120px)",
        paddingBottom: "calc(6rem + 120px)", // might need to adjust 120px if needed for more padding
      }}
    >
      <div className="max-w-3xl px-6">
        <div className="text-base md:text-lg leading-relaxed mb-6">
          {blok.body &&
            (typeof blok.body === "string"
              ? blok.body
              : customRenderRichText(blok.body))}
        </div>

        <p className="text-sm md:text-base opacity-90">{blok.sub_text}</p>
      </div>
    </section>
  );
};

export default QuoteFeature;
